import { render, staticRenderFns } from "./RomMobileMenu.vue?vue&type=template&id=56b4bb5f&scoped=true&"
import script from "./RomMobileMenu.vue?vue&type=script&lang=js&"
export * from "./RomMobileMenu.vue?vue&type=script&lang=js&"
import style0 from "./RomMobileMenu.vue?vue&type=style&index=0&id=56b4bb5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b4bb5f",
  null
  
)

export default component.exports